export function getRequestUrl(url: string | null) {
  if (!url) {
    return '';
  }

  return encodeURI('?returnUrl=' + url);
}
